export default function SettingsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z"
        stroke="#EFE8DE"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5065 7.56562C18.7322 7.88875 18.9298 8.23062 19.0971 8.58749L21.5253 9.93749C21.8284 11.2954 21.8316 12.7032 21.5346 14.0625L19.0971 15.4125C18.9298 15.7694 18.7322 16.1112 18.5065 16.4344L18.5534 19.2187C17.5243 20.1565 16.3064 20.8629 14.9815 21.2906L12.5909 19.8562C12.1976 19.8844 11.8029 19.8844 11.4096 19.8562L9.02838 21.2812C7.69929 20.8613 6.47734 20.1576 5.44713 19.2187L5.494 16.4437C5.27019 16.1161 5.0727 15.7713 4.90338 15.4125L2.47525 14.0625C2.17681 12.704 2.17361 11.2973 2.46588 9.93749L4.90338 8.58749C5.07071 8.23062 5.2683 7.88875 5.494 7.56562L5.44713 4.78124C6.47618 3.84352 7.69411 3.13705 9.019 2.70937L11.4096 4.14374C11.8029 4.11561 12.1976 4.11561 12.5909 4.14374L14.9721 2.71874C16.3012 3.13864 17.5232 3.84238 18.5534 4.78124L18.5065 7.56562Z"
        stroke="#EFE8DE"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
